/// <amd-module name="Wit/QueriesHub/Common/Components/CopyUrlDialog" />
import * as React from "react";
import { getTFSPageData } from "Tfs/Platform/Page";
import { ObservableValue } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { VssComponent } from "VSS/Platform/Layout";
import { Dialog } from "VSSUI/Dialog";
import { TextField } from "VSSUI/TextField";
import { copyToClipboard } from "VSSUI/Utils/ClipboardUtils";
import { QueryType } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IQueryService } from "Wit/Common/QueryService/IQueryService";
import { getQueryUrl } from "Wit/Common/QueryUtils/RoutingUtils";
import { TempQueryUtils } from "Wit/Common/Utilities/TempQueryUtils";
import * as Resources from "Wit/QueriesHub/Resources";


export interface ICopyUrlDialogProps {
    onDismiss: () => void;
    pageContext: IVssPageContext;
    queryType: QueryType;
    wiql: string;
}

export class CopyUrlDialog extends VssComponent<ICopyUrlDialogProps> {
    private url = new ObservableValue<string>("");
    private textFieldRef = React.createRef<TextField>();

    public componentDidMount() {
        const projectId = getTFSPageData(this.context.pageContext)?.project?.id ?? "";
        const queryService = this.context.pageContext.getService<IQueryService>("IQueryService");
        queryService.generateWiql(projectId).then((wiql: string) => {
            TempQueryUtils.beginCreateTemporaryQueryId(this.context.pageContext, this.props.wiql, this.props.queryType).then((queryId: string) => {
                const projectUrl = getQueryUrl(this.props.pageContext, "", "", queryId);
                const uriParts = window.location.href.split("/");
                const orgUrl = uriParts.slice(0, 3).join("/");
                this.url.value = orgUrl + projectUrl;

                requestAnimationFrame(() => {
                    if (this.textFieldRef.current) {
                        this.textFieldRef.current.focus();
                        this.textFieldRef.current.setSelectionRange(0, this.url.value.length);
                    }
                });
            });
        });
    }

    public render() {
        return (
            <Dialog
                titleProps={{ text: Resources.CopyDialogTitle }}
                onDismiss={this.props.onDismiss}
                footerButtonProps={[
                    {
                        text: Resources.Close,
                        onClick: this.props.onDismiss
                    },
                    {
                        text: Resources.Copy,
                        onClick: this.onCopy,
                        primary: true
                    }
                ]}
                resizable={true}
            >
                <div className="scroll-auto flex-grow flex-row">
                    <div>
                        <p>{Resources.CopyDialogMessage}</p>
                        <p className="font-weight-semibold">{Resources.CopyDialogNote}</p>
                        <TextField ref={this.textFieldRef} multiline={true} value={this.url} readOnly={true}></TextField>
                    </div>
                </div>
            </Dialog>
        );
    }

    private onCopy = () => {
        copyToClipboard(this.url.value);
    };
}
